import { dataHooks } from '../../../../libs/dataHooks';

export const megaMenuDropdownSectionDataHooks = dataHooks<{
  headingItemLink: { id: string };
  itemLink: { id: string };
}>('mega-menu-dropdown-section');
